import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Container, Row, Card, CardBody, Col,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { v4 } from 'uuid';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import SearchBar from '../shared/components/K1sSearchBar';
import AvDataGrid from '../shared/components/AvDataGrid';
import useSuccessReports from '../shared/hooks/useSuccessReports';
import createSuccessReportsTableDefinition from './SuccessReportsTableDefinition';
import useFilteredBySearch from '../shared/hooks/useFilteredBySearch';
import formatDateTimeString from '../shared/utils/formatDateTimeString';
import downloadFile from '../shared/utils/downloadFile';
import {
  getSuccessReportsCsv,
} from '../shared/services/apiGateway';

const createTableData = (data) => {
  const tableData = [];
  if (data) {
    for (const k1 of data) {
      tableData.push({
        ...k1,
        id: v4(),
        userName: k1.firstName ? `${k1.firstName} ${k1.lastName}` : '',
        uploadDateTime: formatDateTimeString(k1.uploadDateTime),
      });
    }
  }
  return tableData;
};
function SuccessReports() {
  const [loadingSuccessReports, setSuccessReportsLoading] = useState(true);
  const successReports = useSuccessReports(setSuccessReportsLoading);
  const successReportsTableDef = createSuccessReportsTableDefinition(useHistory());
  const [searchValue, setSearchValue] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const filteredSuccessReports = createTableData(useFilteredBySearch(successReports, searchValue));
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <>
      <Helmet>
        <title>Success Logs</title>
      </Helmet>
      <Container>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <h2>Success Logs</h2>
                <div style={{ marginTop: '20px' }}>
                  <SearchBar
                    placeholder="Search"
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                    disabled={loadingSuccessReports}
                    fullWidth
                  />
                </div>
                <div style={{ marginTop: '20px' }}>
                  <AvDataGrid
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    rows={filteredSuccessReports}
                    columns={successReportsTableDef}
                    loading={loadingSuccessReports}
                    initialState={{
                      sorting: {
                        sortModel: [
                          { field: 'uploadDateTime', sort: 'desc' },
                        ],
                      },
                    }}
                  />
                </div>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  spacing={2}
                  mt={2}
                >
                  <LoadingButton
                    variant="contained"
                    color="secondary"
                    disabled={isSubmitting || loadingSuccessReports}
                    loading={isSubmitting || loadingSuccessReports}
                    onClick={async () => {
                      setIsSubmitting(true);
                      const response = await getSuccessReportsCsv();
                      const csvData = response.data;
                      downloadFile(csvData, `k1-success-export-${new Date().toISOString()}.csv`);
                      setIsSubmitting(false);
                    }}
                  >
                    Download As CSV
                  </LoadingButton>
                </Stack>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>

  );
}

export default SuccessReports;
